// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-h26C","title":"styles_title__cSCVM","text":"styles_text__DTWX1"};